const TagStyle =
  "text-xs font-semibold bg-neutral-500/10 dark:bg-neutral-500/20 hover:bg-neutral-200 dark:hover:bg-neutral-500/10 rounded-[12px] px-3 py-1 hover:animate-scale ";
export default TagStyle;
